import React,  { useState, useEffect }  from "react";
import LineGraph from "../../_default/LineGraph";
import DropDown from "../../_default/DropDown";
import { getMultipleDaysMeasurementProgress, getClients, getCLientByName, getCLientById, getAllMeasurementsForCalendar } from "../../../services/firebase/firestore/getData";
import { Link } from "react-router-dom";
import "./graph.scss";

export default function Graph({ dayAmount, user, clientName, selectedClientId }) {
const [graphData, setGraphata] = useState(false);
const [amountOfDays, setAmountOfDays] = useState(dayAmount);

  useEffect(() => {
    if(selectedClientId) {
      getCLientById(selectedClientId, (result) => {
        getAllMeasurementsForCalendar(result.id, (result) => {
          setGraphata(result);
          console.log(result);
        });
        getMultipleDaysMeasurementProgress(result.id, amountOfDays, (result) => {
          console.log(result);
          //setGraphata(result);
        });
      })
    }
  }, [selectedClientId, amountOfDays]);

return(
    <div className="c-graph-container">
        <div className="c-graph-time-selector">
            {selectedClientId && window.location.href.indexOf("clients") === -1? <Link className="c-box-data--link"
                  to={{
                    pathname: "clients/" + selectedClientId,
                    state: {clientPage: "Progress"}     
                  }}>
                  View full progress
                </Link>: ""}
        </div>
        <LineGraph progress={graphData} />
    </div>
);
}
   